import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useOutletContext, useParams } from "react-router-dom";

const User = () => {
    const [user, setUser] = useState([]);
    let { id } = useParams();
    const { jwtToken } = useOutletContext();

    useEffect(() => {
        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + jwtToken);
        const requestOptions = {
            method: "GET",
            headers: headers,
        };
        fetch(
            `${process.env.REACT_APP_BACKEND}/api/users/${id}`,
            requestOptions
        )
            .then((response) => response.json())
            .then((data) => {
                setUser(data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [id]);

    return (
        <div>
            {user && (
                <>
                    <h1>
                        {user.name} {user.lastName}
                    </h1>

                    <div>
                        <Link to={`/users/${user.id}/edit`}>Редактировать</Link>
                    </div>

                    <table className="table table-stripped table-hover">
                        <tbody>
                            <tr>
                                <td>Email:</td>
                                <td>{user.email}</td>
                            </tr>
                            <tr>
                                <td>Роль:</td>
                                <td>{user.roleTitle}</td>
                            </tr>
                            <tr>
                                <td>Активность</td>
                                <td>{user.active ? "Да" : "Нет"}</td>
                            </tr>
                            <tr>
                                <td>Город</td>
                                <td>{user.town && user.town.name}</td>
                            </tr>
                            <tr>
                                <td>Email</td>
                                <td>{user.email}</td>
                            </tr>
                            <tr>
                                <td>Телефон</td>
                                <td>{user.phone}</td>
                            </tr>
                            <tr>
                                <td>Баланс</td>
                                <td>{user.balanceFormatted}</td>
                            </tr>
                        </tbody>
                    </table>
                </>
            )}

            {!user && <h1>Пользователь не найден</h1>}
        </div>
    );
};

export default User;
